import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4l-4.5 0","key":"svg-0"}],["path",{"d":"M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4l-4.5 0","key":"svg-1"}]]

const IconBrandInertia = createReactComponent('outline', 'brand-inertia', 'BrandInertia', __iconNode);

export default IconBrandInertia;